const class2type = {};
const toString = class2type.toString;
const hasOwn = class2type.hasOwnProperty;
"Boolean Number String Function Array Date RegExp Object Error Symbol".split(" ").forEach(function(item) {
  class2type["[object " + item + "]"] = item.toLowerCase();
});
const type = function(obj) {
  if (obj === null) {
    return obj + "";
  }
  return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj;
};
const isFunction = function(obj) {
  return type(obj) === "function";
};
const isWindow = function(obj) {
  return obj !== null && obj === obj.window;
};
const isPlainObject = function(obj) {
  let key;
  if (!obj || type(obj) !== "object" || obj.nodeType || isWindow(obj)) {
    return false;
  }
  try {
    if (obj.constructor && !hasOwn.call(obj, "constructor") && !hasOwn.call(obj.constructor.prototype, "isPrototypeOf")) {
      return false;
    }
  } catch (e) {
    return false;
  }
  for (key in obj) {
  }
  return key === void 0 || hasOwn.call(obj, key);
};
const isArray = Array.isArray || function(obj) {
  return type(obj) === "array";
};
function extend(...args) {
  let src, copyIsArray, copy, name, options, clone, target = args[0] || {}, i = 1, deep = false;
  const length = args.length;
  if (typeof target === "boolean") {
    deep = target;
    target = args[i] || {};
    i++;
  }
  if (typeof target !== "object" && !isFunction(target)) {
    target = {};
  }
  if (i === length) {
    i--;
  }
  for (; i < length; i++) {
    if ((options = args[i]) !== null) {
      for (name in options) {
        src = target[name];
        copy = options[name];
        if (target === copy) {
          continue;
        }
        if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
          if (copyIsArray) {
            copyIsArray = false;
            clone = src && isArray(src) ? src : [];
          } else {
            clone = src && isPlainObject(src) ? src : {};
          }
          target[name] = extend(deep, clone, copy);
        } else if (copy !== void 0) {
          target[name] = copy;
        }
      }
    }
  }
  return target;
}

export { extend };
//# sourceMappingURL=extend.mjs.map
